type MetricPoint = { ts: number; value: number }
type MetricPointNullable = { ts: number; value: number | null }

// Builds a fixed-interval grid from startTs to endTs; slots with no data
// within half an interval become null, producing visible gaps in the chart.
export const buildMetricGrid = (
  points: MetricPoint[],
  intervalMs: number,
  startTs: number,
  endTs: number
): MetricPointNullable[] => {
  const tolerance = intervalMs / 2
  const result: MetricPointNullable[] = []

  for (let ts = startTs; ts <= endTs; ts += intervalMs) {
    const match = points.find((p) => Math.abs(p.ts - ts) <= tolerance)
    result.push({ ts, value: match?.value ?? null })
  }

  return result
}
